/**
* A part of a template
*/
export class TemplatePart {
    /**
     * The oulet name
     */
    public name: string;
    /**
     * Indicates whether the outlet is the default navigation target
     */
    public isDefaultNavigationTarget: boolean;
    /**
     * Indicates the deault route name for the outlet
     */
    public defaultRouteName: string;
}
